import { useState } from 'react';
import Segmented from '@/components/base/Segmented';
import WholesaleClients from './components/WholesaleClients';
import WholesalePrices from './components/WholesalePrices';
import WholesaleHistory from './components/WholesaleHistory';

type Tab = 'clients' | 'prices' | 'history';

export default function WholesalePage() {
  const [tab, setTab] = useState<Tab>('clients');

  const options = [
    { value: 'clients', label: 'Clientes mayoristas' },
    { value: 'prices', label: 'Precios mayoristas' },
    { value: 'history', label: 'Historial' },
  ];

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">Mayoristas</h1>
          <p className="mt-1 text-foreground-600">
            Clientes mayoristas con código único y precios por cantidad.
          </p>
        </div>
      </div>

      <div className="mt-6 overflow-x-auto">
        <Segmented options={options} value={tab} onChange={(v) => setTab(v as Tab)} />
      </div>

      <div className="mt-6">
        {tab === 'clients' && <WholesaleClients />}
        {tab === 'prices' && <WholesalePrices />}
        {tab === 'history' && <WholesaleHistory />}
      </div>
    </div>
  );
}